import React from "react";
import { Box, AspectRatio } from "@chakra-ui/react";
import Image from "next/image";
import Marquee from "react-fast-marquee";
import { Button } from "ui/button";
import { TextTitle } from "ui/text";
import { LightGradientBackground } from "components/hero";
import Balancer from "react-wrap-balancer";
import sdOffsitePhoto from "../../../public/assets/company/careers/sd-surfing.png";
import foundersPhoto from "../../../public/assets/company/careers/founders.png";
import companyPhoto from "../../../public/assets/company/careers/austin-company.png";
import austinDinnerPhoto from "../../../public/assets/company/careers/austin-dinner.png";
import austinPicnicPhoto from "../../../public/assets/company/careers/austin-picnic.png";

const marqueeImages = [
  {
    src: companyPhoto,
    alt: "Large group of team members.",
    transform: "rotate(1deg)",
  },
  {
    src: austinPicnicPhoto,
    alt: "Team members at a park in Austin for a company off-site event.",
    transform: "rotate(3deg)",
  },

  {
    src: austinDinnerPhoto,
    alt: "Team members at dinner in Austin for a company off-site event.",
    transform: "rotate(-1deg)",
  },
  {
    src: foundersPhoto,
    alt: "Founders of Hightouch.",
    transform: "rotate(-3deg)",
  },
  {
    src: sdOffsitePhoto,
    alt: "Team members on the beach with surfboards for a San Diego off-site event.",
    transform: "rotate(2deg)",
  },
];

export function CareersHero({ title, openPositionsId }: { title: string; openPositionsId: string }) {
  return (
    <LightGradientBackground fullWidth variant="blue" pt="huge">
      <TextTitle
        align="center"
        mobileAlign="center"
        size="xl"
        titleAs="h1"
        title={<Balancer>{title}</Balancer>}
        actions={
          <Button pulse="light" href={`#${openPositionsId}`}>
            View open positions
          </Button>
        }
      />

      <Box width="100%" mt="biggest" sx={{ "> div": { mx: { base: -4, xl: 0 }, width: "auto" } }}>
        <Marquee pauseOnClick gradientWidth={0} speed={50} style={{ overflow: "hidden" }}>
          {marqueeImages.map((image) => (
            <Box key={image.alt} py="small" mx={{ base: "small", md: "bigger" }} transform={image.transform}>
              <AspectRatio
                ratio={3 / 2}
                width={{ base: "2xs", sm: "xs", lg: "md", xl: "lg" }}
                fontSize={0}
                pos="relative"
                borderRadius="base"
                overflow="hidden"
              >
                <Image
                  priority
                  fill
                  sizes="100%"
                  src={image.src}
                  alt={image.alt}
                  style={{ objectFit: "cover" }}
                  placeholder="blur"
                />
              </AspectRatio>
            </Box>
          ))}
        </Marquee>
      </Box>
    </LightGradientBackground>
  );
}
